module.exports = __webpack_public_path__ + "img/SurreyS.a9a2dd3b.png";